import React from 'react';
import reportWebVitals from './reportWebVitals.js';
import { createRoot, hydrateRoot } from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import './index.css';
import './css/components/scrollbar.css';
import Home from './screens/home/index.jsx';
import Auth from './screens/auth/index.jsx';
import ScreenDownload from './screens/download/index.jsx';
import PrivacyPolicies from './screens/privacyPolicies/index.jsx';
import TermsOfUse from './screens/termsOfUse/index.jsx';


const app = (
    <React.StrictMode>
        <HelmetProvider>
            <BrowserRouter>
                <Routes>

                    {/* <================== LANDING ROUTE ==================> */}
                    <Route path="/" element={<Home />}/>
                    <Route path="/downloads" element={<ScreenDownload />}/>
                    <Route path="/privacy-policies" element={<PrivacyPolicies />}/>
                    <Route path="/terms-of-use" element={<TermsOfUse />}/>

                    {/* <================== AUTH ROUTE ==================> */}
                    <Route path="/auth/:authToken/*" element={<Auth />} />

                </Routes>
            </BrowserRouter>
        </HelmetProvider>
    </React.StrictMode>
);

const rootElement = document.getElementById('root');

// Páginas pré-renderizadas pelo react-snap (Fase 5) chegam com o DOM já
// populado — nesse caso precisamos hidratar em vez de renderizar do zero.
if (rootElement.hasChildNodes()) {
    hydrateRoot(rootElement, app);
} else {
    createRoot(rootElement).render(app);
}

reportWebVitals();
